import React from 'react';
import { motion } from 'framer-motion';
const team = [{
  name: 'Yuvraj Damir',
  title: 'Director of Sales',
  initials: 'YD'
}, {
  name: 'Atul Mohan',
  title: 'General Manager',
  initials: 'AM'
}, {
  name: 'Rathnakar G',
  title: 'Associate Sales',
  initials: 'RG'
}, {
  name: 'Sagar Gambhir',
  title: 'Associate Sales',
  initials: 'SG'
}];
export function TeamSection() {
  return <section className="bg-[#f2f2f4] py-24 md:py-32 px-6" data-id="element-311">
      <div className="max-w-7xl mx-auto" data-id="element-312">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-313">
          <span className="text-[#c9a961] text-[13px] font-bold tracking-[0.2em] uppercase mb-4 block" data-id="element-314">
            Leadership
          </span>
          <h2 className="font-display text-[40px] md:text-[56px] font-medium text-[#1d1d1f] mb-6" data-id="element-315">
            Our Team
          </h2>
          <div className="w-20 h-[1px] bg-[#c9a961] mx-auto mb-8" data-id="element-316" />
          <p className="text-[#86868b] text-[18px] md:text-[20px] max-w-2xl mx-auto font-light" data-id="element-317">
            The passionate leaders behind BV Group Hospitality's success
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-318">
          {team.map((member, index) => <motion.div key={member.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-white p-10 text-center border border-[#d8d8dc] hover:border-[#c9a961] transition-all duration-500 hover:shadow-lg group" data-id="element-319">
              <div className="w-24 h-24 mx-auto bg-[#f2f2f4] rounded-full flex items-center justify-center mb-8 text-[#c9a961] text-2xl font-display font-medium border border-[#d8d8dc] group-hover:bg-[#c9a961] group-hover:text-white transition-colors duration-500" data-id="element-320">
                {member.initials}
              </div>
              <h3 className="font-display text-[22px] font-medium text-[#1d1d1f] mb-2" data-id="element-321">
                {member.name}
              </h3>
              <p className="text-[#86868b] text-[14px] uppercase tracking-wider" data-id="element-322">
                {member.title}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}